export const extractParams = (router: any) => {
  const query = router.query;
  let type = 'unit';
  let report = 'latest';
  if (query && query.type) type = query.type as string;
  if (query && query.report) report = query.report as string;
  return { type, report }
}